+ (($) ->
  'use strict'

  

  AboutIndex =
    init: ->
      @addBlankDiv()
      @calculatorImageHeight()
      

 
    addBlankDiv: ->
      div = document.createElement('div')
      div.className = 'view-width-active'
      document.body.appendChild div

    imageHeight: () ->
      
      $('.about-left-banner').each ->
        # isMobile = $(window).width() < 768
        isMobile = ( $('.view-width-active').css('position') is 'relative' ) ? true : false
        rightSideBar = $(@).next()
        rightSidebarHeight = if isMobile then 0 else rightSideBar.outerHeight() 
        # if isMobile
        #   console.log '--is Mobile--'
        # else
        #   console.log '--Not Mobile--' + rightSideBar.outerHeight()
        
        $(@).css
          height: rightSidebarHeight

    calculatorImageHeight: ->
      $(window).on
        load: ->
          # isMobile = $(window).width() < 768
          # isTablet = $(window).width() < 950
          # isMobile = ( $('.view-width-tester').css('float') is 'none' ) ? true : false
          AboutIndex.imageHeight()
        resize: ->
          # isMobile = $(window).width() < 768
          # isMobile = ( $('.view-width-tester').css('float') is 'none' ) ? true : false
          AboutIndex.imageHeight()



  








  

  $ ->
    AboutIndex.init()

)(jQuery)
